// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3_DfJ","emails":"CreateEditClinics_emails__2v9a1","emailTagLabel":"CreateEditClinics_emailTagLabel__2DhGS"};